import { render, staticRenderFns } from "./RtpAgentManagement.vue?vue&type=template&id=93055d94&scoped=true&"
import script from "./RtpAgentManagement.vue?vue&type=script&lang=ts&"
export * from "./RtpAgentManagement.vue?vue&type=script&lang=ts&"
import style0 from "./RtpAgentManagement.vue?vue&type=style&index=0&id=93055d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93055d94",
  null
  
)

export default component.exports